import { ChatInterface } from "./chat-interface";
import { type DisplayMessage, RoomMeta } from "../../types";
import { ReadyState } from "react-use-websocket";

interface YoutubeLayoutProps {
  roomId: string;
  youtubeVideoId: string;
  messages: DisplayMessage[];
  sendMessage: (username: string, message: string) => void;
  connectionStatus: string;
  chatError: string | null;
  readyState: ReadyState;
}

export function YoutubeLayout({
  roomId,
  youtubeVideoId,
  messages,
  sendMessage,
  connectionStatus,
  chatError,
  readyState,
}: YoutubeLayoutProps) {

  return (
    <div className="flex h-dvh w-full flex-col bg-slate-100 md:flex-row">
      {/* Video Player Area */}
      <div className="w-full md:w-2/3 lg:w-3/4">
        <div className="aspect-video w-full bg-black">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* Chat Sidebar Area */}
      <div className="flex flex-grow flex-col bg-white md:w-1/3 lg:w-1/4">
        <ChatInterface
          roomId={roomId}
          messages={messages}
          sendMessage={sendMessage}
          connectionStatus={connectionStatus}
          chatError={chatError}
          readyState={readyState}
          isSidebar={true}
          isYoutubeRoom={true}
        />
      </div>
    </div>
  );
}
